import { createRouter, createWebHistory } from 'vue-router';
import Login from './views/LoginPage.vue';
import Register from './views/RegisterPage.vue';
import Dashboard from './views/DashBoard.vue';
import indexPage from './views/indexPage.vue';
import SearchResultPage from './views/SearchResultPage.vue';
import ExamPaperPage from './views/ExamPaperPage.vue'; // Changed to ExamPaperPage


// And properly registered in routes
const routes = [
  {
    path: '/',
    name: 'indexPage',
    component: indexPage,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      {
        path: 'courses',
        name: 'DashboardCourses',
        component: () => import('./views/dashboard/Courses.vue')
      },
      {
        path: 'collections',
        name: 'DashboardCollections',
        component: () => import('./views/dashboard/Collections.vue')
      },
      {
        path: 'third-party/settings',
        name: 'ThirdPartySettings',
        component: () => import('./views/dashboard/ThirdPartySettings.vue')
      },
      {
        path: 'third-party/stats',
        name: 'ThirdPartyStats',
        component: () => import('./views/dashboard/ThirdPartyStats.vue')
      }
    ]
  },
  // 添加管理员统计页面路由（独立页面）
  
  {
    path: '/search',
    name: 'SearchResult',
    component: SearchResultPage,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/exam/:id&:fromDashboard',
    name: 'ExamPaper',
    component: ExamPaperPage, // Changed to use ExamPaperPage
    props: true
  },

  

];



const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 添加路由守卫设置标题
router.afterEach((to) => {
  const baseTitle = 'ZError题库';
  if (to.meta.title) {
    document.title = `${to.meta.title} | ${baseTitle}`;
  } else {
    document.title = baseTitle;
  }
});

export default router;

